import axios from 'axios';

// const API_BASE_URL = 'http://localhost:8080/api/ai';

const API_URL = process.env.REACT_APP_API_URL + '/ai';

export const fetchAiAlertsFromApi = async () => {
  try {
    const response = await axios.get(`${API_URL}/alerts`);
    return response.data;
  } catch (error) {
    console.error("Error fetching alerts:", error);
    throw error;
  }
};